import React from 'react'
import { Route, Redirect } from 'react-router-dom'

const ProtectedRoute = ({ children, ...rest }) => {
    const user = localStorage.getItem('user')
    return (
        <Route
            {...rest}
            render={({ location }) => {
                if (user) {
                    return { children }
                }
                return (
                    <Redirect
                        to={{
                            pathname: '/',
                            state: { from: location },
                        }}
                    />
                )
            }}
        />
    )
}

export default ProtectedRoute
